import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useThreadDepth(fromDate: string, toDate: string) {
  return useQuery({
    queryKey: ["platformAnalytics", "threadDepth", fromDate, toDate],
    queryFn: () =>
      api.getThreadDepth({ from_date: fromDate, to_date: toDate }),
  });
}
